if(!customElements.get('instagram-slider')) {
  class InstagramSlider extends HTMLElement {
    constructor() {
      super();
      this.breakpoint = 1280;
    }

    destroySlider() {
      if(!this.slider) return;

      this.slider.destroy();
    }

    initSlider() {
      if(this.slider) return this.slider.resize();

      this.slider = new Flickity(this, {
        pageDots: false,
        wrapAround: true,
        arrowShape: 'M 10 50 L 50 90 L 55 85 L 20 50 L 55 15 L 50 10 Z',
        cellAlign: 'center',
      });

      this.slider.resize();
    }

    connectedCallback() {
      if(!Flickity) return;

      if(window.innerWidth < 1280) this.initSlider();

      window.addEventListener('resize', () => { 
        if(window.innerWidth > 1280) return this.destroySlider();
        
        this.initSlider();
      });

      this.observer = new MutationObserver(() => {
        if(this.slider) this.slider.resize();

        if(window.innerWidth < 1280) this.initSlider();

        window.addEventListener('resize', () => { 
          if(window.innerWidth > 1280) return this.destroySlider();
          
          this.initSlider();
        });
      });

      this.observer.observe(this, { childList: true, subtree: true });

      this.interval = window.setInterval(() => {
        if(!this.slider) return;
      
        this.slider.reloadCells();
        this.slider.resize();
        
        const slide = this.querySelector('instagram__item');
        
        if(slide) this.slider.style.height = slide.clientHeight + 'px';

        window.clearInterval(this.interval);
      }, 1000);
    }
  }

  customElements.define('instagram-slider', InstagramSlider);
}
